import { atomFamily, atom } from 'recoil';

var shareTokenPageNumberState = atomFamily({
    key: "ShareTokenPageNumberState",
    "default": 1
});
var shareTokenPageSizeState = atomFamily({
    key: "ShareTokenPageSizeState",
    "default": 5
});
var shareTokenCurrentTemplateIdState = atom({
    key: "ShareTokenCurrentTemplateIdState",
    "default": 0
});
var shareTokensRequestIdState = atomFamily({
    key: "ShareTokensRequestIdState",
    "default": 0
});

export { shareTokenCurrentTemplateIdState, shareTokenPageNumberState, shareTokenPageSizeState, shareTokensRequestIdState };
//# sourceMappingURL=atoms.js.map
